/* Package JSON Import will be here */
import React, { Fragment } from "react";
import { Table, Tab, Pagination, Button, Modal, Grid, Search } from 'semantic-ui-react';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
/* Package JSON Import will be here */

/* Project Import will be here */
import { Constants } from '../../../config/appConstants';
import NoResultFound from "../../sharedComponent/noResultFound";
import "../timeCard.css";
/* Project Import will be here */

const TimeCardDailyDetailsComponent = props => {
    const panes = [
        {
            menuItem: 'Daily Details Inspection',
            render: () => <Tab.Pane>
                <Table celled padded striped>
                    <Table.Header className="header-bg" style={{ size: 'small' }}>
                        <Table.Row>
                            <Table.HeaderCell className="projectNumber">
                                Project Number
                            </Table.HeaderCell>
                            <Table.HeaderCell className="deviceName">
                                Device Name
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellDescription">
                                Weather
                            </Table.HeaderCell>
                            <Table.HeaderCell className="tableCellSubsVisit">
                                Subs or Visitors
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Inspection Description
                            </Table.HeaderCell>
                            <Table.HeaderCell >
                                Initials
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body className="noData">
                        {props.timeCardDailyDetails.dailyDetailsInspection && props.timeCardDailyDetails.dailyDetailsInspection.length > 0 ? props.timeCardDailyDetails.dailyDetailsInspection.map(data => (
                            <Table.Row verticalAlign="top">
                                <Table.Cell>{data.projectNumber}</Table.Cell>
                                <Table.Cell style={{ wordBreak: 'break-all' }}>{data.deviceName}</Table.Cell>
                                <Table.Cell style={{ wordBreak: 'break-all' }}>{data.weather}</Table.Cell>
                                <Table.Cell style={{ wordBreak: 'break-all' }}>{data.subsOrVisitors}</Table.Cell>
                                <Table.Cell className="tableCellDescription">{data.inspectionDescription && data.inspectionDescription.length > 500 ? data.inspectionDescription.substring(0, 500) : data.inspectionDescription}</Table.Cell>
                                <Table.Cell>{data.inspectionInitial && data.inspectionInitial.length > 20 ? data.inspectionInitial.substring(0, 20) : data.inspectionInitial}</Table.Cell>
                            </Table.Row>
                        ))
                            :
                            <Table.Row style={{ width: '100%' }}>
                                <Table.Cell colSpan="6">
                                    <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                </Table.Cell>
                            </Table.Row>
                        }


                    </Table.Body>
                    {props.timeCardDailyDetails.dailyDetailsInspection && props.timeCardDailyDetails.dailyDetailsInspection.length > 0 && <Table.Footer>
                        <Table.Row>
                            <Table.HeaderCell colSpan='13'>
                                <Pagination floated="right"
                                    activePage={props.timeCardDailyDetails.pagination.activePage}
                                    onPageChange={props.paginationChange}
                                    ellipsisItem={null}
                                    firstItem={null}
                                    lastItem={null}
                                    totalPages={props.timeCardDailyDetails.pagination.totalCount}
                                />
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Footer>
                    }
                </Table>
            </Tab.Pane>
        },
        {
            menuItem: 'Daily Details Equipment',
            render: () =>
                <Tab.Pane>
                    <Table celled padded striped>
                        <Table.Header className="header-bg" style={{ size: 'small' }}>
                            <Table.Row>
                                <Table.HeaderCell className="projectNumber">
                                    Project Number
                                </Table.HeaderCell>
                                <Table.HeaderCell className="deviceName">
                                    Device Name
                                </Table.HeaderCell>
                                <Table.HeaderCell className="tableCellDescription">
                                    Weather
                                </Table.HeaderCell>
                                <Table.HeaderCell className="tableCellSubsVisit">
                                    Subs or Visitors
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    Equipment Description
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    Productive Hours
                                </Table.HeaderCell>
                                <Table.HeaderCell >
                                    Idle Hours
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body className="noData">
                            {props.timeCardDailyDetails.dailyDetailsEquipment && props.timeCardDailyDetails.dailyDetailsEquipment.length > 0 ? props.timeCardDailyDetails.dailyDetailsEquipment.map(data => (
                                <Table.Row verticalAlign="top">
                                    <Table.Cell>{data.projectNumber}</Table.Cell>
                                    <Table.Cell style={{ wordBreak: 'break-all' }}>{data.deviceName}</Table.Cell>
                                    <Table.Cell style={{ wordBreak: 'break-all' }}>{data.weather}</Table.Cell>
                                    <Table.Cell style={{ wordBreak: 'break-all' }}>{data.subsOrVisitors}</Table.Cell>
                                    <Table.Cell className="tableCellDescription">{data.equipmentDescription}</Table.Cell>
                                    <Table.Cell>{data.productiveHours}</Table.Cell>
                                    <Table.Cell>{data.idleHours}</Table.Cell>
                                </Table.Row>
                            ))
                                :
                                <Table.Row style={{ width: '100%' }} >
                                    <Table.Cell colSpan="7">
                                        <NoResultFound displayMessage={Constants.NO_RESULT_FOUND} />
                                    </Table.Cell>
                                </Table.Row>
                            }


                        </Table.Body>
                        {props.timeCardDailyDetails.dailyDetailsEquipment && props.timeCardDailyDetails.dailyDetailsEquipment.length > 0 && <Table.Footer>
                            <Table.Row>
                                <Table.HeaderCell colSpan='14'>
                                    <Pagination floated="right"
                                        activePage={props.timeCardDailyDetails.pagination.activePage}
                                        onPageChange={props.paginationChange}
                                        ellipsisItem={null}
                                        firstItem={null}
                                        lastItem={null}
                                        totalPages={props.timeCardDailyDetails.pagination.totalCount}
                                    />
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Footer>
                        }
                    </Table>
                </Tab.Pane>
        }
    ]
    return (
        <Fragment>
            <Modal
                open={props.timeCardDailyDetails.isModalVisible}
                onOpen={props.openModal}
                onClose={() => props.closeModal()}
                size='fullscreen'
                closeIcon
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header className="headerColor text-color">Daily Details for All Projects</Modal.Header>
                <Modal.Content scrolling>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Tab onTabChange={props.onTabChange} panes={panes} className="tabMenu" />
                                <div className="searchDateInput">
                                    <Search onSearchChange={props.onDailyDetailsSearch} placeholder={Constants.SEARCH_PLACEHOLDER} />
                                    <div className="timeCardDate">
                                        <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                            <KeyboardDatePicker
                                                className="dailyFieldDate"
                                                placeholder="MM/dd/yyyy"
                                                value={props.timeCardDailyDetails.selectedDate}
                                                onChange={date => props.handleDateChange(date)}
                                                inputProps={{ readOnly: true }}
                                                format="MM/dd/yyyy"
                                                inputVariant="outlined"
                                                primary
                                                disableFuture={false}
                                                {...(props.timeCardDailyDetails.minimumDate ? { minDate: props.timeCardDailyDetails.minimumDate } : {})}
                                                {...(props.timeCardDailyDetails.calendarMaxDate ? { maxDate: props.timeCardDailyDetails.calendarMaxDate } : props.timeCardDailyDetails.maximumDate ? { maxDate: props.timeCardDailyDetails.maximumDate } : {})}
                                            />
                                        </MuiPickersUtilsProvider>
                                    </div>
                                </div>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button secondary className="backButtonSpacing" type="button" primary onClick={() => props.closeModal()}>Back</Button>
                </Modal.Actions>
            </Modal>
        </Fragment>
    );
}

export default TimeCardDailyDetailsComponent;

TimeCardDailyDetailsComponent.displayName = "TimeCardDailyDetailsComponent";